import { Button } from '@vrplatform/components';
import { OwnerPortalPreviewStart } from '@vrplatform/data';
import { parseAsString, useQueryStates } from '@vrplatform/query-params';
import { isUUID } from '@vrplatform/utils';
import { useNavigate } from 'react-router';
import { EmptyViewWrapper, FullPageLoadingIndicator } from '../components';

/**
 * `/owner-preview?team=…&contact=…`, opened in a new tab from the owner menu
 * and by Restart of an expired preview. Starts the preview and sends the tab
 * to the address it opens on.
 */
export const OwnerPortalPreviewEntry = () => {
  const [{ team, contact }] = useQueryStates({
    team: parseAsString,
    contact: parseAsString,
  });
  const navigate = useNavigate();

  if (!team || !contact || !isUUID(team) || !isUUID(contact))
    return (
      <EmptyViewWrapper
        title="Invalid owner portal preview link"
        description="Open the preview again from the owner's menu."
        actions={
          <Button variant="primary" onClick={() => navigate('/')}>
            Back to dashboard
          </Button>
        }
      />
    );

  return (
    <OwnerPortalPreviewStart
      target={{ teamId: team, contactId: contact }}
      renderStatus={(status) =>
        status.status === 'loading' ? (
          <FullPageLoadingIndicator
            message="Starting owner portal preview..."
            showSignOut={false}
          />
        ) : (
          <EmptyViewWrapper
            title="Owner portal preview unavailable"
            description={status.error.message}
            actions={
              <>
                <Button
                  variant="primary"
                  onClick={() => window.location.reload()}
                >
                  Try again
                </Button>
                <Button onClick={() => navigate('/')}>Back to dashboard</Button>
              </>
            }
          />
        )
      }
    />
  );
};
